import { useSubscription } from '@apollo/client'

import { INBOX_STATUS_UPDATES_SUBSCRIPTION } from './graphql'

export function useInboxStatusUpdatesSubscription() {
  useSubscription(INBOX_STATUS_UPDATES_SUBSCRIPTION, { ignoreResults: true })
}
